export default process.env.REACT_APP_USE_LEMONSOFT_B2C === 'true' ||
  localStorage.getItem('useLemon') === 'true'
